import { atom } from "jotai";

export interface MenuState {
  notifs: {
    notification?: boolean;
  };
}

export const menuAtom = atom<MenuState>({
  notifs: {},
});
